import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL
if(sessionStorage.getItem("accessToken")){
    axios.defaults.headers.common['Authorization'] = `Bearer ${sessionStorage.getItem("accessToken")}`
}
export default axios